import { TRACK_USER_ACTION_INTERCEPTOR_ID } from '../../track-user-actions/track-user-actions-interceptor.service';
import { EntityType } from '@miq/domain';
import { SearchTrackingInfo } from '../../track-user-actions/track-user-actions.component.model';
import { ISearchFilterSettings } from '../../models/isearch-filter-settings.model';
import { isAExternalAvailabilityReviewer } from '@shared/resolvers/user-info.resolver';

// FROM SERVER
export interface FilterSetResponse {
  property?: ISearchFilterSettings[];
  availability: ISearchFilterSettings[];
  company?: ISearchFilterSettings[];
  lease?: ISearchFilterSettings[];
  sale?: ISearchFilterSettings[];
  contact?: ISearchFilterSettings[];
  tim?: ISearchFilterSettings[];
  tenancy?: ISearchFilterSettings[];
  brand?: ISearchFilterSettings[];
}

// TO SERVER
export class RangeValue {
  eq?: any; // might not be used
  from?: any;
  to?: any;
}

export class QueryCriteria {
  type: string; // equals | range | or
  key?: number;
  field?: string | string[]; // property.address.city
  values?: RangeValue | any; // string | number |  string[] | number[];
  dataType?: string; // text, int...
  name?: string;
  includeEmpty?: boolean;
  excludeEmpty?: boolean;
  condition?: string;
  excludeSelection?: boolean;
  typeAhead?: boolean;
  /**
   * Selected compound filters for this criterion.
   * Stored without `values`; parent values are injected at wire-build time
   * via injectCompoundFilterValues before the search request is sent.
   * Persisted to localStorage and saved searches.
   */
  compoundFilters?: QueryCriteria[];
}

export class GeographyCriteria {
  districts?: number[];
  neighborhoods?: number[];
  submarkets?: number[];
  propertyTypes?: number[];
  markets: number[];
}
export interface PageMarker {
  penultimateLeaseId: number;
  lastFloorSuite: {
    floorSuiteId: number;
    leaseId: number;
  };
}

export interface SotConfigItem {
  value: any;
  dataType: any;
}

export interface SortConfig {
  prevRecordSort: SotConfigItem[];
  currRecordSort: SotConfigItem[];
}

export interface SpacesQuery {
  includeComposedCount: boolean;
  pageMarker?: PageMarker;
  skipSpacesLimit?: boolean;
  disableTotalCount?: boolean;
  sort?: any[];
}

export class FilterRequest {
  userId?: number;
  entity?: string;
  filters: QueryCriteria[];
  geography?: GeographyCriteria;
  limit?: number;
  offset?: number;
  sort?: Sorting;
  multiSort?: Sorting[];
  after?: number[];
  [TRACK_USER_ACTION_INTERCEPTOR_ID]?: SearchTrackingInfo;
  skipDefaultFilters?: boolean;
  searchEngine?: string;
  spacesQuery?: SpacesQuery;
}

export interface SearchHeaders {
  values?: any[];
  columnId?: number;
  field: string;
  key?: number;
  header: string;
  width?: string;
  dataType?: string;
  isRightAlign?: boolean;
  options?: { sortable?: boolean };
}

/**
 * MIQ Landing Page Sorting Interface
 */
export interface Sorting {
  field: string;
  order: string | number;
  dataType: any;
  /**
   * Optional If sorting is handled by column id rather than field
   */
  columnId?: number;
  last?: any;
  nextToLast?: any;
}

export interface StatsRequest {
  id: number;
  periodType: string;
  usage: string[];
}

export const SEARCH_FILTER_REQUEST_BY_ENTITY = Object.freeze({
  [EntityType.Company]: { skipDefaultFilters: true },
});

export const getSearchFilterRequestByUserGroupAndEntity = (entity: EntityType) => {
  if (entity === EntityType.Availability) {
    return isAExternalAvailabilityReviewer() ? { skipDefaultFilters: true } : {};
  }

  return SEARCH_FILTER_REQUEST_BY_ENTITY[entity] || {};
};
